import React, { useCallback, useEffect } from 'react'
import { useRecoilValue, useRecoilState } from 'recoil'
import {
  selectedClients as selectedClientsState,
  currentSection as currentSectionState,
  currentFix as currentFixState,
  lastSection as lastSectionState,
} from '../../store/uiStore'
import { siteSections as siteSectionsState } from '../../store/dataStore'
import { DotsNavigation } from '../../styles/headerStyles'

const Dots = () => {
  const menuLinks = useRecoilValue(siteSectionsState).slice(1)
  const [currentSection, setCurrentSection] = useRecoilState(
    currentSectionState
  )
  const [selectedClients, setSelectedClients] = useRecoilState(
    selectedClientsState
  )
  const [lastSection, setLastSection] = useRecoilState(
    lastSectionState
  )
  const [currentFix, setCurrentFix] = useRecoilState(
    currentFixState
  )

  const handleDotClick = useCallback(
    (section) => {
      if (currentFix !== section) {
        if (section === 'clientes' || section === 'aliados') {
          setCurrentSection((last) => 'clientes')
          setSelectedClients((last) => section === 'clientes' ? 0 : 1)
        } else {
          setCurrentSection((last) => section)
        }
        setLastSection((last) => currentFix)
        setCurrentFix((last) => section)
      }
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [lastSection]
  )
  useEffect(() => {
    if ( currentSection === 'clientes' ) {
      setCurrentFix((last) => selectedClients === 0 ? currentSection : 'aliados')
    } else {
      setCurrentFix((last) => currentSection)
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [lastSection])
  return (
    <DotsNavigation>
      {Object.entries(menuLinks).map(([id, { link, slug }]) => (
          <li key={`dot-${slug}`}>
            <button
              className={currentFix === slug ? 'active' : ''}
              onClick={() => handleDotClick(slug)}>
              <span>{link}</span>
            </button>
          </li>
        ))}
    </DotsNavigation>
  )
}

export default Dots
